export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/lockIcon.acebb327.svg","height":18,"width":16,"blurWidth":0,"blurHeight":0};